module.exports = __webpack_public_path__ + "static/media/Square-Outline.e4cca6f5.png";